module.exports = __webpack_public_path__ + "static/media/ABNB_Report_IPOIntelligence_a_base.54b772bf.png";